<template>
  <a
    :rel="rel_"
    :href="url"
    class="section"
    @mouseover="overImage"
    @mouseleave="leaveImage"
    @Touchstart="overImage"
    @Touchend="leaveImage"
  >
    <img :src="resolve_img_url(image_)" :alt="alt" class="image-section" />
    <div class="text-index" v-show="seen">
      {{ text }}
      <br />
      {{ english_text }}
    </div>
  </a>
</template>

<script>
export default {
  name: "SectionImage",
  props: {
    text: String,
    english_text: String,
    alt: String,
    leave_image: String,
    over_image: String,
    url: String,
    rel_: String,
  },
  data() {
    return {
      image_: this.leave_image,
      text_: this.text,
      seen: false,
    };
  },
  created() {
    if (window.innerWidth < 1000) {
      this.image_ = this.over_image;
      this.seen = true;
    } else {
      this.image_ = this.leave_image;
      this.seen = false;
    }
  },
  methods: {
    overImage() {
      this.image_ = this.over_image;
      this.seen = true;
    },
    leaveImage() {
      this.image_ = this.leave_image;
      this.seen = false;
    },
    resolve_img_url: function (path) {
      let images = require.context(
        "../assets/index/",
        false,
        /\.png$|\.jpg$|\.gif/
      );
      return images(`./${path}`);
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Paprika&display=swap");
.text-index {
  color: #03ff00;
  font-size: 24px;
  font-family: "Paprika", regular, serif;
  max-width: 230px;
  height: 0;
  z-index: 100;
  position: relative;
  top: -150px;
}

.section {
  margin-right: 1px;
  text-decoration: none;
}

.image-section {
  height: 235px;
  width: 235px;
}

@media only screen and (max-width: 1100px) {
  .text-index {
    top: -100px;
    max-width: 120px;
  }
  .image-section {
    height: 125px;
    width: 125px;
  }
}
</style>
